import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	aifcPromptPlaceholder: {
		id: 'editor-plugin-ai.ExperienceApplication.screens-with-logic.aifcPromptPlaceholder',
		defaultMessage: 'Describe what to do, / for skills, or @ for agents',
		description:
			'Placeholder for the editor AI prompt input in the new AIFC experience, hinting at slash commands for skills and @ mentions for agents.',
	},
	postStreamReviewPromptPlaceholder: {
		id: 'editor-plugin-ai.ExperienceApplication.screens-with-logic.postStreamReviewPromptPlaceholder',
		defaultMessage: 'Press Enter to accept, or describe a change',
		description:
			'Placeholder for the prompt input in the Post Stream Review screen, where pressing Enter accepts the AI changes and typing describes a follow-up change.',
	},
});
